export enum SupplierStatusEnum {
  UNKNOWN = "unknown",
  ACTIVE = "active",
  INACTIVE = "inactive",
}
